module.exports = __webpack_public_path__ + "static/media/modern-luxury-interiors.5f6f3029.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/modern-luxury-interiors.jpg
// module id = 455
// module chunks = 0